/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_ConsultingInputs */

const en_mk_nav_consulting = /** @type {(inputs: Mk_Nav_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to us`)
};

const id_mk_nav_consulting = /** @type {(inputs: Mk_Nav_ConsultingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngobrol dulu`)
};

/**
* | output |
* | --- |
* | "Talk to us" |
*
* @param {Mk_Nav_ConsultingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_consulting = /** @type {((inputs?: Mk_Nav_ConsultingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_ConsultingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_consulting(inputs)
	return en_mk_nav_consulting(inputs)
});